/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



app.filter('schichtOrderFilter', function () {
    return function (input, total) {

        var objs = []
        function compare(a, b) {
            if (a.job.alle_schichten_start < b.job.alle_schichten_start)
                return -1;
            else if (a.job.alle_schichten_start > b.job.alle_schichten_start)
                return 1;
            else
                return 0;
        }
        Object.keys(input).forEach(function (ind) {
            objs.push(input[ind])
        })


        objs.sort(compare);

        return objs;
    };
});

app.filter('schichtOrderFilterManager', function () {
    return function (input, total) {

        var objs = []
        function compare(a, b) {
            if (a.alle_schichten_start < b.alle_schichten_start)
                return -1;
            else if (a.alle_schichten_start > b.alle_schichten_start)
                return 1;
            else
                return 0;
        }
        Object.keys(input).forEach(function (ind) {
            objs.push(input[ind])
        })


        objs.sort(compare);

        return objs;
    };
});